export default __webpack_public_path__ + "static/media/gallery_02.fc6d7837.jpg";